module.exports = Vuetify;


//////////////////
// WEBPACK FOOTER
// external "Vuetify"
// module id = qP68
// module chunks = 26